<template>
	<nuxt-link :to="basePath" class="banner__logo">
		<img
			v-if="isFetching"
			src="/img/gms-myprofile-blue-01.svg"
			width="48"
			height="48"
			class="mr-2"
		/>
		<div v-else class="relative mr-2 flex-shrink-0">
			<avatar v-if="accountName" :username="accountName" :size="48" />
			<avatar
				v-if="accountTeamName && accountTeamName !== accountName"
				:username="accountTeamName"
				:size="20"
				class="absolute bottom-0 self-center ml-8 mt-12"
			/>
		</div>
		<div class="text-grey-darker">
			<div class="text-xs leading-tight">{{ t('CONTRACTOR') }}</div>
			<div class="text-xl leading-none">
				{{ isFetching ? t('LOADING') : accountName }}
			</div>
			<div v-if="!isFetching" class="text-xs">
				<span v-if="accountTeamName && accountTeamName !== accountName">
					{{ accountTeamName }}
				</span>
				<span
					v-else
					class="absolute self-center p-1 rounded-full text-xs bg-blue-darker text-white"
				>
					{{ t('ADMIN') }}
				</span>
			</div>
		</div>
	</nuxt-link>
</template>
<script>
import {GMAvatar as Avatar} from '@gm/components'
import {useAccountService} from "~/services/account";

export default {
	components: { Avatar },
  setup() {
    const { t } = useTranslation()
    const { getBasePath, getAccountName, accountTeamName, isFetchingActiveAccount, isFetchingAccounts } = useAccountService();
    const accountName = computed(() => getAccountName())
    const basePath = computed(() => getBasePath())

    const isFetching = computed(() => {
      return isFetchingAccounts.value || isFetchingActiveAccount.value
    })

    return {
      t,
      basePath,
      isFetching,
      accountName,
      accountTeamName,
    }
  },
}
</script>
